import { useMemo } from "react";
import useCommerceCart from "@vercel/commerce/cart/use-cart";
import { getCartQuery, normalizeCart } from "../utils";
import { SHOPIFY_CART_ID_COOKIE, SHOPIFY_CART_URL_COOKIE } from "../const";
import Cookies from "js-cookie";
export default useCommerceCart;
export const handler = {
    fetchOptions: {
        query: getCartQuery
    },
    async fetcher ({ input: { cartId  } , options , fetch  }) {
        if (cartId) {
            const { cart  } = await fetch({
                ...options,
                variables: {
                    cartId
                }
            });
            // Handle null cart (completed/expired)
            if (!cart) {
                console.log("Cart is null - removing stale cookies");
                Cookies.remove(SHOPIFY_CART_ID_COOKIE);
                Cookies.remove(SHOPIFY_CART_URL_COOKIE);
                return null;
            }
            return cart ? normalizeCart(cart) : null;
        }
        return null;
    },
    useHook: ({ useData  })=>{
        return (input)=>{
            const response = useData({
                swrOptions: {
                    revalidateOnFocus: false,
                    ...input == null ? void 0 : input.swrOptions
                }
            });
            return useMemo(()=>{
                return Object.create(response, {
                    isEmpty: {
                        get () {
                            var ref;
                            return (((ref = response.data) == null ? void 0 : ref.lineItems.length) ?? 0) <= 0;
                        },
                        enumerable: true
                    }
                });
            }, [
                response
            ]);
        };
    }
};
